import React from 'react';
import SectionHeading from '../Typography/SectionHeading/SectionHeading';
import EditButton from '../Typography/EditButton/EditButton';
import {
  trustSummaryLine1,
  trustSummaryLine2,
  trusteeSummaryLine1,
  trusteeSummaryLine2,
  trusteeSummaryLine3
} from './util';
import styles from '../ReviewCombinedPersonalInformation/style.css';

const ReviewTrustInformation = ({
  trust,
  trustee,
  coTrustees = [],
  handleClick
}) => (
  <>
    <div className="review-customer-information">
      <div className="section-header">
        <SectionHeading text="Trust Information">
          <EditButton onClick={handleClick('trust')} currentlyEditing={false} />
        </SectionHeading>
      </div>
      <div className="customer-information-lines">
        <div className="nasu_masking_class">{trustSummaryLine1(trust)}</div>
        <div>{trustSummaryLine2(trust)}</div>
      </div>
      <style jsx>{styles}</style>
    </div>

    <div className="review-customer-information">
      <div className="section-header">
        <SectionHeading text="Trustee Information">
          <EditButton
            onClick={handleClick('trustee')}
            currentlyEditing={false}
          />
        </SectionHeading>
      </div>
      <div className="customer-information-lines">
        <div>{trusteeSummaryLine1(trustee)}</div>
        <div>{trusteeSummaryLine2(trustee)}</div>
        <div className="nasu_masking_class">{trusteeSummaryLine3(trustee)}</div>
      </div>
      <style jsx>{styles}</style>
    </div>
    {coTrustees && coTrustees.length > 0 && (
      <div className="review-customer-information">
        <div className="section-header">
          <SectionHeading text="Co-Trustee Information">
            <EditButton
              onClick={handleClick('trustee')}
              currentlyEditing={false}
            />
          </SectionHeading>
        </div>

        {coTrustees.map(coTrustee => (
          <div
            className="customer-information-lines"
            key={coTrustee.taxID?.slice(-4)}>
            <div>{trusteeSummaryLine1(coTrustee)}</div>
            <div>{trusteeSummaryLine2(coTrustee)}</div>
            <div className="nasu_masking_class">
              {trusteeSummaryLine3(coTrustee)}
            </div>
          </div>
        ))}
        <style jsx>{styles}</style>
      </div>
    )}
  </>
);

export default ReviewTrustInformation;
